import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public showMenu = signal<boolean>(false);

  toggle() {
    this.showMenu.update((showMenu) => !showMenu);
  }
}
